/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        var nav = $(".nav-primary");
        var trigger = $("#hamburger"),
          isClosed = false;

        function burgerTime() {
          if (isClosed === true) {
            trigger.removeClass("is-open");
            trigger.addClass("is-closed");
            nav.slideUp();
            isClosed = false;
          } else {
            trigger.removeClass("is-closed");
            trigger.addClass("is-open");
            nav.slideDown();
            isClosed = true;
          }
        }

        $(".ad-sldier").bxSlider({
          auto: true,
          controls: false,
          pager: false,
          speed: 1500,
          pause: 4500,
        });

        trigger.click(function () {
          burgerTime();
        });

        function navigationToggle() {
          /**
           * Opens submenu on hover
           */
          $(".nav-primary .menu-item-has-children").mouseover(function () {
            $(this).find(".sub-menu").stop().slideDown(300);
          });

          /**
           * Closes sub menu on leave
           */
          $(".nav-primary .menu-item-has-children").mouseleave(function () {
            $(this).find(".sub-menu").stop().slideUp(300);
          });
        }

        $(window).resize(function () {
          if ($(window).width() > 1100) {
            navigationToggle();
          }
        });

        $(window).resize(function () {
          if ($(window).width() > 1100) {
            navigationToggle();
          }
        });

        $(window).load(function () {
          if ($(window).width() > 1100) {
            navigationToggle();
          }
        });

        $(".nav-primary ul li.menu-item-has-children").each(function () {
          $(this).append(
            '<span class="toggle-sub"><i class="fa fa-angle-down"></i></span>'
          );
        });

        $(".nav-primary ul li .toggle-sub").click(function () {
          $(this).prev(".sub-menu").slideToggle();
        });

        $("select[name=member]").change(function () {
          val = $(this).val();
          if (val.indexOf("Yes") !== -1) {
            $(".urn").removeClass("d-none");
          } else {
            $(".urn").addClass("d-none");
            $("input[name=urn]").val("");
          }
        });

        $("select[name=nationality]").change(function () {
          val = $(this).val();
          if (val === "Other") {
            $(".nationality-other").removeClass("d-none");
          } else {
            $(".nationality-other").addClass("d-none");
            $("input[name=nationality-other]").val("");
          }
        });

        $("select[name=referred]").change(function () {
          val = $(this).val();
          if (val.indexOf("Yes") !== -1) {
            $(".reffered").removeClass("d-none");
          } else {
            $(".reffered").addClass("d-none");
            $("input[name=referral]").val("");
          }
        });

        $("#expirationMonth").mask("00");
        $("#expirationYear").mask("0000");
        $("#dob").mask("00/00/0000");

        jQuery.validator.addMethod(
          "phone",
          function (phone_number) {
            phone_number = phone_number.replace(/\s+/g, "");
            return phone_number.match(
              /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|#)\d{3,4})?$/
            );
          },
          "Invalid phone number"
        );

        jQuery.validator.addMethod(
          "postcode",
          function (postcode) {
            postcode = postcode.replace(/\s+/g, "");
            return postcode.match(
              /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/
            );
          },
          "Invalid postcode"
        );

        jQuery.validator.addMethod(
          "date",
          function (date) {
            var regEx =
              /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
            return date.match(regEx);
          },
          "Invalid Date format"
        );

        jQuery.validator.addMethod(
          "month",
          function (date) {
            var regEx = /^(0?[1-9]|1[012])$/;
            return date.match(regEx);
          },
          "Invalid Month"
        );

        const registrationForm = $("#registrationForm");

        registrationForm.validate({
          rules: {
            firstname: {
              required: true,
            },
            surname: {
              required: true,
            },
            email: {
              required: true,
              email: true,
            },
            mobile: {
              required: true,
              phone: true,
            },
            postcode: {
              required: true,
              postcode: true,
            },
            "house-no": {
              required: true,
            },
            dob: {
              required: true,
              date: true,
            },
            nationality: {
              required: true,
            },
            username: {
              required: true,
            },
            password: {
              required: true,
              minlength: 8,
            },
            "confirm-password": {
              equalTo: "#password",
            },
            gender: {
              required: true,
            },
            terms: {
              required: true,
            },
            "card-name": {
              required: true,
            },
            member: {
              required: true,
            },
            "card-number": {
              required: true,
              number: true,
            },
            cvc: {
              required: true,
              minlength: 3,
              maxlength: 3,
              number: true,
            },
            "expiration-month": {
              required: true,
              month: true,
            },
            "expiration-year": {
              required: true,
            },
          },
          messages: {
            terms: "You must agree to the terms and conditions",
          },
        });

        $("#registerSubmit").click(function (e) {
          e.preventDefault();

          $(".msg").empty();

          var response = grecaptcha.getResponse();
          if (response.length === 0) {
            $("#recaptcha-error").removeClass("d-none");
            return false;
          }

          if (registrationForm.valid()) {
            var firstname = $("input[name=firstname]").val();
            var surname = $("input[name=surname]").val();
            var email = $("input[name=email]").val();
            var mobile = $("input[name=mobile]").val();
            var postcode = $("input[name=postcode]").val();
            var gender = $("select[name=gender]").val();
            var welshSpeaker = $("select[name=welsh-speaker]").val();
            var longRunning = $("select[name=long-running]").val();
            var runningGroup = $("select[name=running-group]").val();
            var groupName = $("input[name=group-name]").val();
            var runningLevel = $("select[name=running-level]").val();
            var cardName = $("input[name=card-name]").val();
            var cardNumber = $("input[name=card-number]").val();
            var cvc = $("input[name=cvc]").val();
            var month = $("input[name=expiration-month]").val();
            var year = $("input[name=expiration-year]").val();
            var username = $("input[name=username]").val();
            var password = $("input[name=password]").val();
            var newsletter = $("input[name=newsletter]").val();
            var member = $("select[name=member]").val();
            var urn = $("input[name=urn]").val();
            var referral = $("input[name=referral]").val();
            var dob = $("input[name=dob]").val();
            var houseNo = $("input[name=house-no]").val();
            var nationality = $("select[name=nationality]").val();
            var nationalityOther = $("input[name=nationality-other]").val();

            $.ajax({
              type: "POST",
              dataType: "json",
              url: ajaxurl,
              data: {
                firstname: firstname,
                surname: surname,
                email: email,
                username: username,
                password: password,
                mobile: mobile,
                postcode: postcode,
                gender: gender,
                welshSpeaker: welshSpeaker,
                longRunning: longRunning,
                runningGroup: runningGroup,
                groupName: groupName,
                runningLevel: runningLevel,
                cardName: cardName,
                cardNumber: cardNumber,
                cvc: cvc,
                month: month,
                year: year,
                newsletter: newsletter,
                member: member,
                urn: urn,
                referral: referral,
                houseNo: houseNo,
                dob: dob,
                nationality: nationality,
                nationalityOther: nationalityOther,
                action: "user_registration",
              },
              beforeSend: function () {
                $("#registerSubmit span").text("Loading");
                $("#registerSubmit i").removeClass("d-none");
              },
              success: function (response) {
                $("#registerSubmit span").text("Submit");
                $("#registerSubmit i").addClass("d-none");
                grecaptcha.reset();
                if (!response.success) {
                  window.scrollTo(0, 0);

                  if (response.data.registration_error) {
                    validationError = response.data.registration_error;

                    key = Object.keys(validationError);

                    for (i = 0; i < key.length; i++) {
                      $("input[name='" + key[i] + "']").addClass("error");
                      $(".msg").append(
                        '<div class="alert alert-danger">' +
                          validationError[key[i]] +
                          "</div>"
                      );
                    }
                  }

                  if (response.data.create_user_error) {
                    validationError = response.data.create_user_error.errors;

                    key = Object.keys(validationError);

                    for (i = 0; i < key.length; i++) {
                      $(".msg").append(
                        '<div class="alert alert-danger">' +
                          validationError[key[i]][0] +
                          "</div>"
                      );
                    }
                  }
                } else {
                  window.location.href = response.data.login;
                }
              },
            });
          }
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        $(".hp-carousel").bxSlider({
          auto: true,
          controls: false,
          speed: 3500,
          pause: 3500,
        });

        $(".group-search").click(function () {
          var locationSearch = $(".search-input-location").val();
          var locationName = $(".search-input-name").val();

          if (locationName.length) {
            grpNameSearch = "&grpname=" + locationName;
          } else {
            grpNameSearch = "";
          }

          var url;

          if (locationSearch.length) {
            url =
              homeurl +
              "/group-running/find-a-group/" +
              "?location=" +
              locationSearch +
              "%20Wales%20UK&radius=30" +
              grpNameSearch;
          } else {
            url =
              homeurl +
              "/group-running/find-a-group/" +
              "?location=Wales%20UK&radius=100" +
              grpNameSearch;
          }

          window.location.replace(url);
        });

        var runners = $(".slider").bxSlider({
          slideMargin: 20,
          moveSlides: 1,
          pager: false,
          nextText: "",
          prevText: "",
          preventDefaultSwipeX: false,
          nextSelector: "#next",
          prevSelector: "#prev",
          controls: true,
          autoReload: true,
          breaks: [
            { screen: 460, slides: 1 },
            { screen: 768, slides: 2 },
            { screen: 991, slides: 3 },
            { screen: 1200, slides: 4 },
          ],
        });

        $("#next").click(function () {
          runners.goToPrevSlide();
          return false;
        });

        $("#prev").click(function () {
          runners.goToNextSlide();
          return false;
        });

        var todays = $(".panel .container .inner").bxSlider({
          moveSlides: 1,
          pager: false,
          slideMargin: 0,
          nextText: "",
          prevText: "",
          preventDefaultSwipeX: false,
          nextSelector: "#todayNext",
          prevSelector: "#todayPrev",
          controls: true,
          autoReload: true,
          breaks: [
            { screen: 460, slides: 1 },
            { screen: 768, slides: 2 },
            { screen: 991, slides: 3 },
            { screen: 1200, slides: 4 },
          ],
        });

        $("#todayNext").click(function () {
          todays.goToPrevSlide();
          return false;
        });

        $("#todayPrev").click(function () {
          todays.goToNextSlide();
          return false;
        });

        $(".tab-title").click(function () {
          $("ul.tabs").slideToggle();
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
        $("select").select2();
      },
    },
    start_a_running_group: {
      init: function () {
        // JavaScript to be fired on the about us page
        $("select").select2();
      },
    },
    cychwyn_eich_grwp_rhedeg: {
      init: function () {
        // JavaScript to be fired on the about us page
        $("select").select2();
      },
    },
    find_a_group: {
      init: function () {
        var options = [].slice.call(document.querySelectorAll("option"));
        options.forEach(function (element) {
          element.addEventListener(
            "mousedown",
            function (e) {
              e.preventDefault();
              element.parentElement.focus();
              this.selected = !this.selected;
              return false;
            },
            false
          );
        });
      },
      finalize: function () {
        //submit form ajax call
        /**
         * Query the Search String
         * @param {*} variable
         */
        function getQueryVariable(variable) {
          var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] === variable) {
              return pair[1];
            }
          }
          return false;
        }

        var searchLocation = decodeURIComponent(getQueryVariable("location"));
        var searchRadius = getQueryVariable("radius");
        var searchName = getQueryVariable("grpname");
        var grpNameSrch = "";
        if (searchName !== false) {
          grpNameSrch = decodeURIComponent(searchName);
        }

        if (searchLocation.length > 0) {
          $("#location").val(searchLocation);
        }
        if (searchRadius.length > 0) {
          $("#radius").val(searchRadius);
        }

        $.ajax({
          type: "POST",
          dataType: "json",
          url: ajaxurl,
          data: {
            grpname: grpNameSrch,
            radius: searchRadius,
            location: searchLocation,
            terrain: "",
            meeting_day: "",
            type_of_group: "",
            group_level: "",
            guided_run: "",
            cost: "",
            action: "group_search",
          },
          beforeSend: function () {
            $("#groupFormSubmit").html(
              'Searching <i class="fa fa-spinner fa-pulse"></i>'
            );
          },
          success: function (response) {
            if (response === 0) {
              //no response
              $("#groupFormSubmit").html("Search");
              GroupMap.initMap(response, "map");
            } else {
              //has results
              $("#groupFormSubmit").html("Search");
              GroupMap.initMap(response, "map");
            }
          },
        });

        $("#groupSearchForm").submit(function (
          e,
          searchLocation,
          searchRadius
        ) {
          e.preventDefault();

          var grpname = $("#grpname").val();
          var radius = $("#radius").val();
          var location = $("#location").val();
          var terrain = $("#terrain").val();
          var meeting_day = $("#meeting_day").val();
          var guided_run = $("#guided_run").val();
          var type_of_group = $("#type_of_group").val();
          var group_level = $("#group_level").val();
          var cost = $("#cost").val();

          $.ajax({
            type: "POST",
            dataType: "json",
            url: ajaxurl,
            data: {
              grpname: grpname,
              radius: radius,
              location: location,
              terrain: terrain,
              meeting_day: meeting_day,
              type_of_group: type_of_group,
              group_level: group_level,
              guided_run: guided_run,
              cost: cost,
              action: "group_search",
            },
            beforeSend: function () {
              $("#groupFormSubmit").html(
                'Searching <i class="fa fa-spinner fa-pulse"></i>'
              );
            },
            success: function (response) {
              if (response === 0) {
                //no response
                $("#groupFormSubmit").html("Search");
                GroupMap.initMap(response, "map");
              } else {
                //has results
                $("#groupFormSubmit").html("Search");
                GroupMap.initMap(response, "map");
              }
            },
          });
          return false;
        });
      },
    },
    join_the_community: {
      init: function () {
        // JavaScript to be fired on the about us page
        $("select").select2({ minimumResultsForSearch: -1 });

        $(
          "select[name='socialGroup'],select[name='ethnicity'],select[name='region']"
        ).select2();

        $("input[name='disabilityRadio']").change(function () {
          if ($(this).val() === "yes" || $(this).val() === "Oes") {
            $("select[name='disability']").prop("disabled", false);
            $("textarea[name='support']").prop("disabled", false);
          } else {
            $("select[name='disability']").prop("disabled", true);
            $("textarea[name='support']").prop("disabled", true);
          }
        });

        $("input[name='socialRadio']").change(function () {
          if ($(this).val() === "yes" || $(this).val() === "Ydw") {
            $("select[name='socialGroup']").prop("disabled", false);
          } else {
            $("select[name='socialGroup']").prop("disabled", true);
          }
        });

        $("#submit").click(function () {
          var siteLang = $("input[name='siteLang']").val();
          var firstname = $("input[name='firstname']").val();
          var surname = $("input[name='surname']").val();
          var age = $("select[name='age']").val();
          var gender = $("select[name='gender']").val();
          var region = $("select[name='region']").val();
          var postcode = $("input[name='postcode']").val();
          var email = $("input[name='email']").val();
          var mobile = $("input[name='mobile']").val();
          var disabilityRadio = $(
            "input[name='disabilityRadio']:checked"
          ).val();
          var disability = $("select[name='disability']").val();
          var support = $("textarea[name='support']").val();
          var ethnicity = $("select[name='ethnicity']").val();
          var long = $("select[name='long']").val();
          var often = $("select[name='often']").val();
          var socialRadio = $("input[name='socialRadio']:checked").val();
          var socialGroup = $("select[name='socialGroup']").val();
          var parkRun = $("input[name='parkRun']:checked").val();
          var groupLeader = $("input[name='groupLeader']:checked").val();
          var newsletter = $("input[name='newsletter']:checked").val();

          $(".form-control-feedback").each(function () {
            $(this).text("");
          });

          $.ajax({
            method: "POST",
            url: ajaxurl,
            dataType: "json",
            data: {
              action: "join_community_ajax",
              siteLang: siteLang,
              firstname: firstname,
              surname: surname,
              age: age,
              gender: gender,
              postcode: postcode,
              region: region,
              email: email,
              mobile: mobile,
              disabilityRadio: disabilityRadio,
              disability: disability,
              ethnicity: ethnicity,
              support: support,
              long: long,
              often: often,
              socialRadio: socialRadio,
              socialGroup: socialGroup,
              parkRun: parkRun,
              groupLeader: groupLeader,
              newsletter: newsletter,
            },
            beforeSend: function () {
              $("#submit").html(
                'Submitting <i class="fa fa-spinner fa-pulse"></i>'
              );
            },
            success: function (response) {
              $("#submit").text("Submit");

              var validationError = response.data.errors;
              if (validationError) {
                var key = Object.keys(validationError);

                for (i = 0; i < key.length; i++) {
                  $("input[name='" + key[i] + "']")
                    .closest(".form-group")
                    .addClass("has-danger");
                  $("input[name='" + key[i] + "']")
                    .next(".form-control-feedback")
                    .text(validationError[key[i]]);

                  if (key[i] === "message") {
                    $("textarea[name='" + key[i] + "']")
                      .closest(".form-group")
                      .addClass("has-danger");
                    $("textarea[name='" + key[i] + "']")
                      .next(".form-control-feedback")
                      .html(validationError[key[i]]);
                  }

                  if (
                    key[i] === "age" ||
                    key[i] === "gender" ||
                    key[i] === "disability" ||
                    key[i] === "ethnicity" ||
                    key[i] === "long" ||
                    key[i] === "often" ||
                    key[i] === "socialGroup" ||
                    key[i] === "region"
                  ) {
                    $("select[name='" + key[i] + "']")
                      .closest(".form-group")
                      .addClass("has-danger");
                    $("select[name='" + key[i] + "']")
                      .closest(".form-group")
                      .children(".form-control-feedback")
                      .html(validationError[key[i]]);
                  }
                }
              } else {
                $(".msg-success")
                  .html(
                    '<div class="text-center alert alert-success">' +
                      response.data.success +
                      "</div>"
                  )
                  .fadeIn();

                $("input").each(function () {
                  $(this).val("");
                });

                $("textarea").each(function () {
                  $(this).val("");
                });
              }
            },
          });
        });
      },
    },
    ymuno_ar_gymuned: {
      init: function () {
        // JavaScript to be fired on the about us page
        $("select").select2({ minimumResultsForSearch: -1 });

        $(
          "select[name='socialGroup'],select[name='ethnicity'],select[name='region']"
        ).select2();

        $("input[name='disabilityRadio']").change(function () {
          if ($(this).val() === "yes" || $(this).val() === "Oes") {
            $("select[name='disability']").prop("disabled", false);
            $("textarea[name='support']").prop("disabled", false);
          } else {
            $("select[name='disability']").prop("disabled", true);
            $("textarea[name='support']").prop("disabled", true);
          }
        });

        $("input[name='socialRadio']").change(function () {
          if ($(this).val() === "yes" || $(this).val() === "Ydw") {
            $("select[name='socialGroup']").prop("disabled", false);
          } else {
            $("select[name='socialGroup']").prop("disabled", true);
          }
        });

        $("#submit").click(function () {
          var siteLang = $("input[name='siteLang']").val();
          var firstname = $("input[name='firstname']").val();
          var surname = $("input[name='surname']").val();
          var age = $("select[name='age']").val();
          var gender = $("select[name='gender']").val();
          var region = $("select[name='region']").val();
          var postcode = $("input[name='postcode']").val();
          // var address         = $("textarea[name='address']").val();
          var email = $("input[name='email']").val();
          var mobile = $("input[name='mobile']").val();
          var disabilityRadio = $(
            "input[name='disabilityRadio']:checked"
          ).val();
          var disability = $("select[name='disability']").val();
          var support = $("textarea[name='support']").val();
          var ethnicity = $("select[name='ethnicity']").val();
          //var language        = $("select[name='language']").val();
          var long = $("select[name='long']").val();
          var often = $("select[name='often']").val();
          var socialRadio = $("input[name='socialRadio']:checked").val();
          var socialGroup = $("select[name='socialGroup']").val();
          var parkRun = $("input[name='parkRun']:checked").val();
          var groupLeader = $("input[name='groupLeader']:checked").val();
          var newsletter = $("input[name='newsletter']:checked").val();

          $(".form-control-feedback").each(function () {
            $(this).text("");
          });

          $.ajax({
            method: "POST",
            url: ajaxurl,
            dataType: "json",
            data: {
              action: "join_community_ajax",
              siteLang: siteLang,
              firstname: firstname,
              surname: surname,
              age: age,
              gender: gender,
              postcode: postcode,
              region: region,
              email: email,
              mobile: mobile,
              disabilityRadio: disabilityRadio,
              disability: disability,
              ethnicity: ethnicity,
              support: support,
              long: long,
              often: often,
              socialRadio: socialRadio,
              socialGroup: socialGroup,
              parkRun: parkRun,
              groupLeader: groupLeader,
              newsletter: newsletter,
            },
            beforeSend: function () {
              $("#submit").html(
                'Submitting <i class="fa fa-spinner fa-pulse"></i>'
              );
            },
            success: function (response) {
              $("#submit").text("Submit");

              var validationError = response.data.errors;
              if (validationError) {
                var key = Object.keys(validationError);

                for (i = 0; i < key.length; i++) {
                  $("input[name='" + key[i] + "']")
                    .closest(".form-group")
                    .addClass("has-danger");
                  $("input[name='" + key[i] + "']")
                    .next(".form-control-feedback")
                    .text(validationError[key[i]]);

                  if (key[i] === "message") {
                    $("textarea[name='" + key[i] + "']")
                      .closest(".form-group")
                      .addClass("has-danger");
                    $("textarea[name='" + key[i] + "']")
                      .next(".form-control-feedback")
                      .html(validationError[key[i]]);
                  }

                  if (
                    key[i] === "age" ||
                    key[i] === "gender" ||
                    key[i] === "disability" ||
                    key[i] === "ethnicity" ||
                    key[i] === "long" ||
                    key[i] === "often" ||
                    key[i] === "socialGroup" ||
                    key[i] === "region"
                  ) {
                    $("select[name='" + key[i] + "']")
                      .closest(".form-group")
                      .addClass("has-danger");
                    $("select[name='" + key[i] + "']")
                      .closest(".form-group")
                      .children(".form-control-feedback")
                      .html(validationError[key[i]]);
                  }
                }
              } else {
                $(".msg-success")
                  .html(
                    '<div class="text-center alert alert-success">' +
                      response.data.success +
                      "</div>"
                  )
                  .fadeIn();

                $("input").each(function () {
                  $(this).val("");
                });

                $("textarea").each(function () {
                  $(this).val("");
                });
              }
            },
          });
        });
      },
    },
    faqs: {
      init: function () {
        $(".question").click(function () {
          $(this).next("div").slideToggle();
          $(this).children("span").toggleClass("open");
        });
      },
    },
    cwestiynau_cyffredin: {
      init: function () {
        $(".question").click(function () {
          $(this).next("div").slideToggle();
          $(this).children("span").toggleClass("open");
        });
      },
    },
    category_newyddion: {
      init: function () {
        $(".tab-title").click(function () {
          $("ul.nav-tabs").slideToggle();
        });
      },
      //Get our news js running
      finalize: function () {
        News.init("#news-container");
      },
    },
    category_news: {
      init: function () {
        $(".tab-title").click(function () {
          $("ul.nav-tabs").slideToggle();
        });
      },
      //Get our news js running
      finalize: function () {
        News.init("#news-container");
      },
    },
    category_run_wales_groups: {
      init: function () {
        $(".tab-title").click(function () {
          $("ul.nav-tabs").slideToggle();
        });
      },
      //Get our news js running
      finalize: function () {
        News.init("#groups");
      },
    },
    runner_profile: {
      init: function () {
        var runnersFooter = $(".runner-list ul").bxSlider({
          slideMargin: 0,
          moveSlides: 1,
          pager: false,
          speed: "2000",
          pause: "2000",
          nextText: "",
          prevText: "",
          nextSelector: "#runnerNext",
          prevSelector: "#runnerPrev",
          preventDefaultSwipeX: false,
          controls: true,
          auto: true,
          loop: true,
          autoReload: true,
          breaks: [
            { screen: 460, slides: 1 },
            { screen: 768, slides: 2 },
            { screen: 991, slides: 3 },
            { screen: 1200, slides: 10 },
          ],
        });

        $("#runnerNext").click(function () {
          runnersFooter.goToNextSlide();
          return false;
        });

        $("#runnerPrev").click(function () {
          runnersFooter.goToPrevSlide();
          return false;
        });
      },
      finalize: function () {},
    },

    cysylltu_a_ni: {
      init: function () {
        $("#submit").click(function () {
          var fullname = $("input[name='fullname']").val();
          var email = $("input[name='email']").val();
          var subject = $("input[name='subject']").val();
          var message = $("textarea[name='message']").val();

          $(".form-control-feedback").each(function () {
            $(this).text("");
          });

          $.ajax({
            method: "POST",
            url: ajaxurl,
            dataType: "json",
            data: {
              action: "contact_form_ajax",
              fullname: fullname,
              email: email,
              subject: subject,
              message: message,
            },
            beforeSend: function () {
              $("#submit").html(
                'Submitting <i class="fa fa-spinner fa-pulse"></i>'
              );
            },
            success: function (response) {
              $("#submit").text("Submit");

              var validationError = response.data.errors;
              if (validationError) {
                var key = Object.keys(validationError);

                for (i = 0; i < key.length; i++) {
                  $("input[name='" + key[i] + "']")
                    .closest(".form-group")
                    .addClass("has-danger");
                  $("input[name='" + key[i] + "']")
                    .next(".form-control-feedback")
                    .text(validationError[key[i]]);

                  if (key[i] === "message") {
                    $("textarea[name='" + key[i] + "']")
                      .closest(".form-group")
                      .addClass("has-danger");
                    $("textarea[name='" + key[i] + "']")
                      .next(".form-control-feedback")
                      .html(validationError[key[i]]);
                  }
                }
              } else {
                $(".msg-success")
                  .html(
                    '<div class="text-center alert alert-success">' +
                      response.data.success +
                      "</div>"
                  )
                  .fadeIn();

                $("input").each(function () {
                  $(this).val("");
                });

                $("textarea").each(function () {
                  $(this).val("");
                });
              }
            },
          });
        });
      },
      //Get our news js running
      finalize: function () {},
    },

    contact_us: {
      init: function () {
        $("#submit").click(function () {
          var fullname = $("input[name='fullname']").val();
          var email = $("input[name='email']").val();
          var subject = $("input[name='subject']").val();
          var message = $("textarea[name='message']").val();

          $(".form-control-feedback").each(function () {
            $(this).text("");
          });

          $.ajax({
            method: "POST",
            url: ajaxurl,
            dataType: "json",
            data: {
              action: "contact_form_ajax",
              fullname: fullname,
              email: email,
              subject: subject,
              message: message,
            },
            beforeSend: function () {
              $("#submit").html(
                'Submitting <i class="fa fa-spinner fa-pulse"></i>'
              );
            },
            success: function (response) {
              $("#submit").text("Submit");

              var validationError = response.data.errors;
              if (validationError) {
                var key = Object.keys(validationError);

                for (i = 0; i < key.length; i++) {
                  $("input[name='" + key[i] + "']")
                    .closest(".form-group")
                    .addClass("has-danger");
                  $("input[name='" + key[i] + "']")
                    .next(".form-control-feedback")
                    .text(validationError[key[i]]);

                  if (key[i] === "message") {
                    $("textarea[name='" + key[i] + "']")
                      .closest(".form-group")
                      .addClass("has-danger");
                    $("textarea[name='" + key[i] + "']")
                      .next(".form-control-feedback")
                      .html(validationError[key[i]]);
                  }
                }
              } else {
                $(".msg-success")
                  .html(
                    '<div class="text-center alert alert-success">' +
                      response.data.success +
                      "</div>"
                  )
                  .fadeIn();

                $("input").each(function () {
                  $(this).val("");
                });

                $("textarea").each(function () {
                  $(this).val("");
                });
              }
            },
          });
        });
      },
      //Get our news js running
      finalize: function () {},
    },
    category_parkrun: {
      init: function () {
        $("a[href='#subject-tab']").click(function () {
          $("aside.sidebar .tab-content ul#runner-tab a").hide();
        });

        $("a[href='#runner-tab']").click(function () {
          $("aside.sidebar .tab-content ul#runner-tab a").show();
        });
      },
      //Get our news js running
      finalize: function () {
        News.init("#park-run");
      },
    },
    category_parkrun_cy: {
      init: function () {
        $("a[href='#subject-tab']").click(function () {
          $("aside.sidebar .tab-content ul#runner-tab a").hide();
        });

        $("a[href='#runner-tab']").click(function () {
          $("aside.sidebar .tab-content ul#runner-tab a").show();
        });
      },
      //Get our news js running
      finalize: function () {
        News.init("#park-run");
      },
    },
    resources: {
      init: function () {
        $("select").select2();

        $("#resourceSearch").keyup(function () {
          var filter = $(this).val().toLowerCase();

          $("span.file-name").each(function () {
            if ($(this).text().trim().toLowerCase().indexOf(filter) > -1) {
              $(this).closest("li").show();
            } else {
              $(this).closest("li").hide();
            }
          });
        });

        $("select[name=categories]").change(function () {
          var category = $(this).val();

          $.ajax({
            method: "POST",
            url: ajaxurl,
            dataType: "json",
            data: {
              action: "get_resources_by_category",
              category: category,
            },

            success: function (response) {
              $("ul.resources").empty();
              $("ul.resources").append(response.data.resources);
            },
          });
        });
      },
      //Get our news js running
      finalize: function () {},
    },
    category_meet_our_bloggers: {
      init: function () {
        $("a[href='#subject-tab']").click(function () {
          $("aside.sidebar .tab-content ul#runner-tab a").hide();
        });

        $("a[href='#runner-tab']").click(function () {
          $("aside.sidebar .tab-content ul#runner-tab a").show();
        });
      },
      finalize: function () {
        MeetOurRunners.init("#meet-our-runners-container");
      },
    },
    settings: {
      init: function () {
        jQuery.validator.addMethod(
          "date",
          function (date) {
            var regEx =
              /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/;
            return date.match(regEx);
          },
          "Invalid Date format"
        );

        jQuery.validator.addMethod(
          "month",
          function (date) {
            var regEx = /^(0?[1-9]|1[012])$/;
            return date.match(regEx);
          },
          "Invalid Month"
        );

        const paymentUpdate = $("#paymentUpdate");

        paymentUpdate.validate({
          rules: {
            "card-name": {
              required: true,
            },
            "card-number": {
              required: true,
              number: true,
            },
            cvc: {
              required: true,
              minlength: 3,
              maxlength: 3,
              number: true,
            },
            expirationMonth: {
              required: true,
              month: true,
            },
            expirationYear: {
              required: true,
            },
          },
        });

        $("#updateCard").click(function (e) {
          e.preventDefault();

          $(".msg").empty();

          if (paymentUpdate.valid()) {
            var cardName = $("input[name=card-name]").val();
            var cardNumber = $("input[name=card-number]").val();
            var cvc = $("input[name=cvc]").val();
            var month = $("input[name=expiration-month]").val();
            var year = $("input[name=expiration-year]").val();

            $.ajax({
              type: "POST",
              dataType: "json",
              url: ajaxurl,
              data: {
                cardName: cardName,
                cardNumber: cardNumber,
                cvc: cvc,
                month: month,
                year: year,
                action: "update_card_details",
              },
              beforeSend: function () {
                $("#updateCard span").text("Loading");
                $("#updateCard i").removeClass("d-none");
              },
              success: function (response) {
                $("#updateCard span").text("Update Card Details");
                $("#updateCard i").addClass("d-none");
                if (!response.success) {
                  if (response.data.registration_error) {
                    validationError = response.data.registration_error;

                    key = Object.keys(validationError);

                    for (i = 0; i < key.length; i++) {
                      $("input[name='" + key[i] + "']").addClass("error");
                      $(".msg").append(
                        '<div class="alert alert-danger">' +
                          validationError[key[i]] +
                          "</div>"
                      );
                    }
                  }
                } else {
                  $(".msg").append(
                    '<div class="alert alert-success">' +
                      response.data.message +
                      "</a></div>"
                  );
                  $(".card-number").text(response.data.card_number);
                  $(".card-type").text(response.data.card_type);
                  $(".exp-month").text(response.data.exp_month);
                  $(".exp-year").text(response.data.exp_year);
                  $(":input")
                    .not(":button, :submit, :reset, :hidden, :checkbox, :radio")
                    .val("");
                }
              },
            });
          }
        });

        $("#addCard").click(function (e) {
          e.preventDefault();

          $(".msg").empty();

          if (paymentUpdate.valid()) {
            var cardName = $("input[name=card-name]").val();
            var cardNumber = $("input[name=card-number]").val();
            var cvc = $("input[name=cvc]").val();
            var month = $("input[name=expiration-month]").val();
            var year = $("input[name=expiration-year]").val();
            var mobile = $("input[name=mobile]").val();

            $.ajax({
              type: "POST",
              dataType: "json",
              url: ajaxurl,
              data: {
                cardName: cardName,
                cardNumber: cardNumber,
                cvc: cvc,
                month: month,
                year: year,
                mobile: mobile,
                action: "add_card_details",
              },
              beforeSend: function () {
                $("#addCard span").text("Loading");
                $("#addCard i").removeClass("d-none");
              },
              success: function (response) {
                $("#addCard span").text("Add Card Details");
                $("#addCard i").addClass("d-none");
                if (!response.success) {
                  if (response.data.registration_error) {
                    validationError = response.data.registration_error;

                    key = Object.keys(validationError);

                    for (i = 0; i < key.length; i++) {
                      $("input[name='" + key[i] + "']").addClass("error");
                      $(".msg").append(
                        '<div class="alert alert-danger">' +
                          validationError[key[i]] +
                          "</div>"
                      );
                    }
                  }
                } else {
                  location.reload();
                }
              },
            });
          }
        });
      },
      finalize: function () {},
    },
    page_template_template_news: {
      init: function () {
        $(".tab-title").click(function (e) {
          $(".nav-tabs").slideToggle();
        });

        /**
         * Fetch more news based on category
         *
         * @param {*} offset
         * @param {*} category
         * @param {*} filters
         */
        function getNews(offset, category, filters) {
          $.ajax({
            method: "POST",
            url: ajaxurl,
            dataType: "json",
            data: {
              offset: offset,
              category: category,
              filters: filters,
              action: "load_members_news",
            },
            success: function (response) {
              var news = response.data.news;

              if (filters) {
                $("#news-items").empty();
                $("#news").empty();
              }

              $("#news").append(news);

              offset = $(".content-box figure").length;
            },
          });
        }

        // Switch news tabs
        $(".nav-tabs li a").click(function (e) {
          e.preventDefault();

          $(".nav-tabs li a").removeClass("active");
          $(this).addClass("active");

          var category = $(this).data("category");
          $("#more-news").attr("data-category", category);

          var offset = 0;
          var filters = 1;

          getNews(offset, category, filters);
        });

        // Load more news
        $("#more-news").click(function () {
          var offset = $(".content-box figure").length;
          var category = $(this).data("category");
          var filters = 0;
          getNews(offset, category, filters);
        });
      },
      finalize: function () {},
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
